module.exports = __webpack_public_path__ + "static/media/hospital.a96628d1.jpg";